module.exports = "/assets/images/3730fd6684b6245ac86ea7c802741208.svg";